<template>
  <a-select
    :disabled="disabled"
    :multiple="false"
    :placeholder="placeholder"
    :value="value"
    allow-clear
    option-filter-prop="title"
    show-search
    :virtual="false"
    @change="onChange"
  >
    <template v-if="hideDisabled">
      <a-select-option
        v-for="item in recordsHandled"
        :key="item.id"
        :title="item.name"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </template>
    <template v-else>
      <a-select-option
        :disabled="isDisabled(item.code)"
        v-for="item in records"
        :key="item.id"
        :title="item.name"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </template>


    <template #dropdownRender="{ menuNode: menu }" v-if="addText">
      <v-nodes :vnodes="menu" />
      <a-divider style="margin: 4px 0" />
      <!-- <a-space style="padding: 4px 8px"> -->
      <div style="padding: 4px 12px; cursor: pointer" @mousedown="(e) => e.preventDefault()">
        <router-link to="/material/accessManagement/list">
          <div class="ub ub-ac ub-ps" style="color: #333" @click="toAddInStorageType">
            <plus-outlined /><span style="width: 5px; white-space: nowrap"></span>
            <span
              style="
                margin-left: 2px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              >{{ addText }}</span
            >
          </div>
        </router-link>
      </div>
    </template>
  </a-select>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, PropType, ref, watch } from "vue";
import { AccessManagementService } from "@/views/material/access-management/access-management.service";
import { PlusOutlined } from "@ant-design/icons-vue";
/**
 * 出入库类型选择器
 *
 * take_out_storage_type 出库
 * put_storage_type 入库
 * 使用方式:
 * <StorageTypeSelect type="put_storage_type" v-model:value="formRef.storageType"></StorageTypeSelect>
 */
export default defineComponent({
  isGlobal: true,
  name: "StorageTypeSelect",
  props: {
    hideDisabled:{
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    type: {
      type: String,
      required: true,
    },
    defaultCode: {
      type: String,
    },
    disableArray: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    validArray: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    addText:{
      type:String,
      default:""
    }
  },
  components: {
    VNodes: (_, { attrs }) => {
      return attrs.vnodes;
    },
    PlusOutlined,
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const onChange = async (id) => {
      emit("update:value", id);
      emit("change", id);
    };

    const { disableArray, validArray } = props;
    const isDisabled = (code) => {
      if (disableArray.length) {
        return disableArray.includes(code);
      }
      if (validArray.length) {
        return !validArray.includes(code);
      }
    };

    const { data: records, run, loading } = AccessManagementService.useSimpleListApi();
    watch(
      () => props.defaultCode,
      () => {
        if (props.defaultCode) {
          let val = (records.value as any).find((o) => o.code == props.defaultCode);
          // console.log("🚀 ~ file: index.vue:90 ~ watch ~ val:", val, records.value);
          if (val) {
            emit("update:value", val.id);
          }
        }
      },
      {
        immediate: true,
      }
    );
    let recordsHandled = ref(<any>[])
    onMounted(async () => {
      await run(props.type);
      console.log(records,'records---')
      // console.log(records, "~~~~~~~~~~~~");
      recordsHandled.value = records.value.map(item => {
        console.log(item, 'item---')
        //@ts-ignore
        console.log(disableArray.includes(item.code),'disableArray.includes(item.code)')
        //@ts-ignore
        if(!disableArray.includes(item.code)){
          return {...item}
        }
      })
      recordsHandled.value = recordsHandled.value.filter(item => item !== undefined)
      console.log(recordsHandled,'recordsHandled')
      if (props.defaultCode) {
        let val = (records.value as any).find((o) => o.code == props.defaultCode);
        // console.log("🚀 ~ file: index.vue:90 ~ watch ~ val:", val, records.value);
        if (val) {
          emit("update:value", val.id);
        }
      }
    });
    const toAddInStorageType = () => {};
    return {
      records,
      onChange,
      loading,
      isDisabled,
      toAddInStorageType,
      recordsHandled
    };
  },
});
</script>
